// src/pages/ForgotPassword.jsx
import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const ForgotPassword = () => {
    const { t } = useTranslation();

    const initialValues = {
        email: '',
    };

    const validationSchema = Yup.object({
        email: Yup.string()
            .email(t('login.emailInvalid'))
            .required(t('login.emailRequired')),
    });

    const onSubmit = async (values, { setSubmitting }) => {
        try {
            const response = await axios.post('https://server.dev.dynootech.com/auth/send-password-reset', {
                email: values.email,
            });


            toast.success(
                t('login.resetLinkSent') ||
                'A reset password link has been sent to your email. Please check your inbox.'
            );

        } catch (error) {
            toast.error(error?.response?.data?.message || t('login.somethingWentWrong'));
        }
    };


    return (
        <div className="min-h-screen flex items-center justify-center px-4 bg-white text-black">
            <div className="w-full max-w-md bg-white p-6 rounded-lg shadow-lg">
                <h2 className="text-center text-2xl font-bold mb-6">{t('login.forgotPassword')}</h2>

                <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
                    {({ isSubmitting }) => (
                        <Form className="space-y-4">
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium mb-1">
                                    {t('login.emailLabel')}
                                </label>
                                <Field
                                    type="email"
                                    name="email"
                                    placeholder={t('login.emailPlaceholder')}
                                    className="w-full px-4 py-2 bg-zinc-100 border border-gray-300 rounded focus:outline-none"
                                />
                                <ErrorMessage name="email" component="div" className="text-red-500 text-sm mt-1" />
                            </div>

                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="w-full py-2 bg-primary hover:bg-primary/90 text-white font-bold rounded"
                            >

                                {isSubmitting ? t('login.sending') : t('login.sendResetLink')}
                            </button>
                        </Form>
                    )}
                </Formik>
            </div>
        </div>
    );
};

export default ForgotPassword;
